import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MobileAppSection.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const MobileAppSection = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation({ once: true });
    const imageRef = useScrollAnimation({ once: true });
    const textRef = useScrollAnimation({ once: true });

    return (
        <section 
            id="mobile-app-feature" 
            className={`${styles.mobileAppFeature} animate-on-scroll`}
            ref={sectionRef}
        >
            <div className="container"> {/* Global container */}
                <div className={styles.mobileAppLayout}>
                    <div className={`${styles.mobileAppImage} animate-on-scroll`} ref={imageRef}>
                        <picture>
                            <source srcSet="/images/gg-mobileapp-in-cabin-map-view.webp" type="image/webp" />
                            <img src="/images/gg-mobileapp-in-cabin-map-view.png" alt={t('mobileApp.imageAlt')} loading="lazy" />
                        </picture>
                    </div>
                    <div className={`${styles.mobileAppText} animate-on-scroll`} ref={textRef}>
                        <h2 className={styles.sectionTitle}>{t('mobileApp.title')}</h2>
                        <p>{t('mobileApp.description')}</p>
                        <a 
                            href="https://play.google.com/store/apps/details?id=tech.greengrowth.blue" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className={styles.downloadBtnLink}
                        >
                            <img 
                                src={`${process.env.PUBLIC_URL}/images/googleplay.png`} 
                                alt={t('mobileApp.googlePlayAlt')} 
                                className={styles.googlePlayImage}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MobileAppSection;
